import React from 'react'
import Shimmer from './Shimmer'

const InputShimmer = () => {
    return (
        <Shimmer>
            <div className='flex w-full flex-col gap-3' >
                <div className="bg-gray-500 w-3/5 flex items-center justify-center h-4 rounded-lg" />
                <div className="bg-gray-500 w-full flex items-center justify-center h-11 rounded-lg" />
            </div>
        </Shimmer>
    )
}

export default InputShimmer